(function () {
  (function () {
    var docEl = document.documentElement
    var resize = function () {
      var clientWidth = docEl.clientWidth
      docEl.style.fontSize = (clientWidth / 16) + 'px' // 2560/160 = 13.3333
    }
    window.addEventListener('resize', resize)
    resize()
  })()
})()